module.exports = require("./yo.d.ts");